import React from 'react';

import { useGetLibraryItemTransactions } from '../../../api/getLibraryItemTransactions';

const TreatmentsTabHeader = ({ documentId }) => {
  const treatmentsQuery = useGetLibraryItemTransactions({
    libraryItemId: documentId,
  });
  const totalCount = treatmentsQuery.data?.data.transactions.length ?? 0;
  return <React.Fragment>Treatment {totalCount > 0 && `(${totalCount})`}</React.Fragment>;
};
export default TreatmentsTabHeader;
